import { linkTemplates } from '@atlassian/mpac-utils';

import BootstrapConfig from '../../../../../../../bootstrapConfig';

export const makeLinkTemplates = () => {
  const {
    adminHubBaseUrl,
    mpacBaseUrl,
    mpacCdnBaseUrl,
    atlassianCommunityBaseUrl,
    macBaseUrl,
    wacBaseUrl,
  } = BootstrapConfig.get();

  return linkTemplates({
    adminHubBaseUrl,
    mpacBaseUrl,
    mpacCdnBaseUrl,
    atlassianCommunityBaseUrl,
    macBaseUrl,
    wacBaseUrl,
  });
};

// https://hello.atlassian.net/wiki/spaces/TENT/pages/2186553116/Server+Apps+that+support+Server+to+Cloud+Migration
export const serverEOLAppsWithDcVersionAvailable = [
  'com.riadalabs.jira.plugins.userdeactivator',
  'com.botronsoft.jira.configurationmanager',
  'com.botronsoft.jira.rollout.integrity-check',
  'com.k15t.backbone.backbone-issue-sync',
  'com.exalate.jiranode',
  'co.uk.jackgraves.jira-optimiser',
  'com.adaptavist.microscope',
  'com.botronsoft.jira.poweradmin',
  'de.resolution.user-deactivator.confluence',
  'com.botronsoft.jira.cloudmigrationtool',
];
